import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel} from '../../shared';
import {Core2Config} from '../../shared';
import {Observable} from 'rxjs';

interface NonReimbursableClaimReportBodyRequest {
  expense_txn_glcode: string;
  expense_txn_glname: string;
  employee_code: string;
  employee_name: string;
  date_submission_from: string;
  date_submission_to: string;
  expense_cost_center_comp_hdr_guids: string[];
  expense_cost_center_branch_guids: string[];
  claim_item_hdr_guids: string[];
  claim_statuses: string[];
}

// bl_aat_claim_cycle_non_reimbursable_report_dto {
// private UUID expense_cost_center_comp_hdr_guid;
// private UUID expense_cost_center_branch_guid;
// private String branch_name;
// private String expense_txn_glcode;
// private String expense_txn_glname;
// private UUID claimant_entity_hdr_guid;
// private String employee_code;
// private String employee_name;
// private String claim_id;
// private ZonedDateTime date_submission;
// private UUID claim_item_hdr_guid;
// private String claim_item_name;
// private BigDecimal claim_amount_incl_tax;
// private String claim_status
//   }


@Injectable({
  providedIn: 'root'
})
export class NonReimbursableClaimReportService  extends BaseApiTemplateService<any> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
    Core2Config.CLAIMS_PREFIX + 'cycle-reports/non-reimbursable-reports/generation/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-reports/non-reimbursable-reports/generation/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'cycle-reports/non-reimbursable-reports/generation/backoffice-ep';
    this.httpClient = http;
  }

  getNonReimbursableClaimsReport(body: any, apiVisa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/cycle-reports/non-reimbursable-reports/generation/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/cycle-reports/non-reimbursable-reports/generation/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

  exportNonReimbursableClaimsReport(body: any, apiVisa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    let apiUrl = Core2Config.DOMAIN_URL + 'core2/tnt/dm/erp/aat/claims/cycle-reports/non-reimbursable-reports/audit-trail-export/backoffice-ep';
    if (apiVisa && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + 'core2/tnt/dm/erp/aat/claims/cycle-reports/non-reimbursable-reports/audit-trail-export/backoffice-ep';
    }
    return this.httpClient.post<BasicApiResponseModel<any>>(apiUrl, body, this.getHttpHeader(apiVisa));
  }

}


